import { DeviceService } from '@/services/device.service'

export default {
  methods: {
    async handleConfirmAction(item, role) {
      const confirm = await this.$bvModal.msgBoxConfirm(
        role === 'SA'
          ? 'Bạn có chắc chắn muốn xác nhận yêu cầu này?'
          : 'Bạn có chắc chắn muốn duyệt yêu cầu này?',
        {
          title: 'Xác nhận',
          okTitle: 'Đồng ý',
          cancelTitle: 'Hủy',
          centered: true,
        }
      )
      if (!confirm) return

      try {
        this.showLoading = true
        let response
        if (role === 'SA') {
          response = await DeviceService.confirmRequestTicket({ id: item.id })
        } else if (role === 'GDV') {
          response = await DeviceService.approveRequestTicket({ id: item.id })
        }

        this.showLoading = false
        if (response.code === 1000) {
          const successMsg =
            role === 'SA' ? 'Xác nhận yêu cầu thành công' : 'Duyệt yêu cầu thành công'
          await this.$bvModal.msgBoxOk(successMsg, {
            title: 'Thành công',
            okTitle: 'Đóng',
            centered: true,
            okVariant: 'success',
          })
          if (this.fetchData) this.fetchData()
        } else {
          this.$bvModal.msgBoxOk(response?.message || 'Có lỗi xảy ra', {
            title: 'Thất bại',
            okTitle: 'Đóng',
            centered: true,
            okVariant: 'danger',
          })
        }
      } catch (error) {
        this.showLoading = false
        this.$bvModal.msgBoxOk(error.message || 'Có lỗi xảy ra', {
          title: 'Thất bại',
          okTitle: 'Đóng',
          centered: true,
          okVariant: 'danger',
        })
      } finally {
        this.showLoading = false
      }
    },

    async handleRejectAction(item, role) {
      const h = this.$createElement
      const messageVNode = h('div', { class: 'form-group' }, [
        h('label', { class: 'font-weight-bold' }, [
          'Lý do',
          h('span', { class: 'text-danger' }, '*'),
        ]),
        h('textarea', {
          ref: 'rejectValue',
          class: 'form-control f12',
          style: { height: '100px' },
          attrs: { placeholder: 'Nhập lý do...' },
        }),
      ])

      try {
        const value = await this.$bvModal.msgBoxConfirm([messageVNode], {
          title: 'Từ chối yêu cầu',
          okTitle: 'Xác nhận',
          cancelTitle: 'Hủy',
          centered: true,
          size: 'md',
        })

        if (value) {
          const reason = this.$refs.rejectValue.value
          if (!reason || !reason.trim()) {
            this.$toast.error('Vui lòng nhập lý do từ chối')
            return
          }

          this.showLoading = true
          const body = {
            id: item.id,
            reasonReject: reason,
          }
          let response
          if (role === 'SA') {
            response = await DeviceService.rejectConfirmRequestTicket(body)
          } else if (role === 'GDV') {
            response = await DeviceService.rejectRequestTicket(body)
          }
          this.showLoading = false
          if (response.code === 1000) {
            await this.$bvModal.msgBoxOk('Đã từ chối thành công', {
              title: 'Thành công',
              okTitle: 'Đóng',
              centered: true,
              okVariant: 'success',
            })
            if (this.fetchData) this.fetchData()
          } else {
            this.$bvModal.msgBoxOk(response?.message || 'Có lỗi xảy ra', {
              title: 'Thất bại',
              okTitle: 'Đóng',
              centered: true,
              okVariant: 'danger',
            })
          }
        }
      } catch (error) {
        this.showLoading = false
        this.$bvModal.msgBoxOk(error.message || 'Có lỗi xảy ra', {
          title: 'Thất bại',
          okTitle: 'Đóng',
          centered: true,
          okVariant: 'danger',
        })
      } finally {
        this.showLoading = false
      }
    },
  },
}
